import { render, staticRenderFns } from "./cardGal.vue?vue&type=template&id=66e65584"
import script from "./cardGal.vue?vue&type=script&lang=js"
export * from "./cardGal.vue?vue&type=script&lang=js"
import style0 from "./cardGal.vue?vue&type=style&index=0&id=66e65584&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports